module.exports = __webpack_public_path__ + "assets/img/Type E (47).0d65a002.jpg";